const button = {
  root: {
    borderRadius: '5px',
    roundedBorderRadius: '2rem',
    gap: '0.5rem',
    paddingX: '{spacing.s}',
    paddingY: '{form.field.padding.y}',
    iconOnlyWidth: '2.5rem',
    sm: {
      fontSize: '0.875rem',
      paddingX: '1.05rem',
      paddingY: '0.25rem',
      lineHeight: 1.5,
    },
    lg: {
      fontSize: '{sizes.l}',
      paddingX: '1.2rem',
      paddingY: '0.4rem',
      lineHeight: 1.5,
    },
    xs: {
      fontSize: '{sizes.xs}',
      paddingX: '0.75rem',
      paddingY: '0.25rem',
      lineHeight: 1,
      fontWeight: '400',
      borderRadius: '{border.radius.m}',
    },
    label: {
      fontWeight: '700',
      fontSize: '{sizes.m}',
    },
    raisedShadow: '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      offset: '{focus.ring.offset}',
    },
    badgeSize: '1rem',
    transitionDuration: '{form.field.transition.duration}',
    lineHeight: '1.5rem',
    marginBottom: '2.8px',
    height: '{form.field.height}',
    iconOnly: {
      iconSize: {
        small: '15px',
        medium: '20px',
        large: '35px',
      },
    },
  },
  colorScheme: {
    light: {
      root: {
        primary: {
          background: '{primary.color}',
          hoverBackground: '{primary.hover.color}',
          activeBackground: '{primary.hover.color}',
          borderColor: 'transparent',
          hoverBorderColor: '{primary.hover.color}',
          activeBorderColor: '{primary.hover.color}',
          color: '{primary.contrast.color}',
          hoverColor: '{primary.contrast.color}',
          activeColor: '{primary.contrast.color}',
          focusRing: {
            color: '{primary.color}',
            shadow: 'none',
          },
        },
        secondary: {
          background: '{secondary.color}',
          hoverBackground: '{secondary.hover.color}',
          activeBackground: '{secondary.hover.color}',
          borderColor: 'transparent',
          hoverBorderColor: '{secondary.hover.color}',
          activeBorderColor: '{secondary.hover.color}',
          color: '{secondary.contrast.color}',
          hoverColor: '{secondary.contrast.color}',
          activeColor: '{secondary.contrast.color}',
          focusRing: {
            color: '{secondary.color}',
            shadow: 'none',
          },
        },
        info: {
          background: '{sky.500}',
          hoverBackground: '{sky.600}',
          activeBackground: '{sky.700}',
          borderColor: '{sky.500}',
          hoverBorderColor: '{sky.600}',
          activeBorderColor: '{sky.700}',
          color: '#ffffff',
          hoverColor: '#ffffff',
          activeColor: '#ffffff',
          focusRing: {
            color: '{sky.500}',
            shadow: 'none',
          },
        },
        success: {
          background: '{green.500}',
          hoverBackground: '{green.600}',
          activeBackground: '{green.700}',
          borderColor: '{green.500}',
          hoverBorderColor: '{green.600}',
          activeBorderColor: '{green.700}',
          color: '#ffffff',
          hoverColor: '#ffffff',
          activeColor: '#ffffff',
          focusRing: {
            color: '{green.500}',
            shadow: 'none',
          },
        },
        warn: {
          background: '{warning.color}',
          hoverBackground: '#c07b08',
          activeBackground: '#c07b08',
          borderColor: 'transparent',
          hoverBorderColor: '#c07b08',
          activeBorderColor: '#c07b08',
          color: '{warning.contrast.color}',
          hoverColor: '{warning.contrast.color}',
          activeColor: '{warning.contrast.color}',
          focusRing: {
            color: '{warning.color}',
            shadow: 'none',
          },
        },
        help: {
          background: '{purple.500}',
          hoverBackground: '{purple.600}',
          activeBackground: '{purple.700}',
          borderColor: '{purple.500}',
          hoverBorderColor: '{purple.600}',
          activeBorderColor: '{purple.700}',
          color: '#ffffff',
          hoverColor: '#ffffff',
          activeColor: '#ffffff',
          focusRing: {
            color: '{purple.500}',
            shadow: 'none',
          },
        },
        danger: {
          background: '{error.color}',
          hoverBackground: '#6e1616',
          activeBackground: '#6e1616',
          borderColor: 'transparent',
          hoverBorderColor: '#631414',
          activeBorderColor: '#631414',
          color: '{error.contrast.color}',
          hoverColor: '{error.contrast.color}',
          activeColor: '{error.contrast.color}',
          focusRing: {
            color: '{error.color}',
            shadow: 'none',
          },
        },
        iconOnly: {
          background: 'linear-gradient(to bottom, var(--p-white), var(--p-gray-scale-100))',
          hoverBackground: '{primary.background.color}',
          activeBackground: '{primary.background.color}',
          borderColor: '#d9d9d9',
          hoverBorderColor: '{gray.scale.400}',
          activeBorderColor: '{gray.scale.400}',
          color: '{gray.scale.400}',
          hoverColor: '{primary.color}',
          activeColor: '{primary.color}',
          focusRing: {
            borderColor: '{inputtext.focus.border.color}',
            shadow: '{inputtext.focus.ring.shadow}',
            outline: {
              width: '{inputtext.focus.ring.width}',
              style: '{inputtext.focus.ring.style}',
              color: '{inputtext.focus.ring.color}',
              offset: '{inputtext.focus.ring.offset}',
            },
          },
        },
        contrast: {
          background: '{white}',
          hoverBackground: '#ececec',
          activeBackground: '#ececec',
          borderColor: '{white}',
          hoverBorderColor: '#ececec',
          activeBorderColor: '#ececec',
          color: '{primary.color}',
          hoverColor: '{primary.color}',
          activeColor: '{primary.color}',
          focusRing: {
            color: '{white}',
            shadow: 'none',
          },
        },
      },
      outlined: {
        primary: {
          borderColor: '{primary.color}',
          disabledBorderColor: 'gray',
          color: '{primary.color}',
          disabledColor: 'gray',
          hoverBackground: '{primary.color}',
          hoverColor: '{white}',
          activeBackground: '{primary.hover.color}',
          activeColor: '{primary.color}',
          background: '{white}',
        },
        secondary: {
          borderColor: 'rgb(211, 217, 226)',
          disabledBorderColor: 'rgb(211, 217, 226)',
          color: '{primary.color}',
          disabledColor: 'gray',
          hoverColor: 'rgb(19, 58, 90)',
        },
        success: {
          hoverBackground: '{green.50}',
          activeBackground: '{green.100}',
          borderColor: '{green.200}',
          color: '{green.500}',
        },
        info: {
          hoverBackground: '{sky.50}',
          activeBackground: '{sky.100}',
          borderColor: '{sky.200}',
          color: '{sky.500}',
        },
        warn: {
          hoverBackground: '{orange.50}',
          activeBackground: '{orange.100}',
          borderColor: '{orange.200}',
          color: '{orange.500}',
        },
        help: {
          hoverBackground: '{purple.50}',
          activeBackground: '{purple.100}',
          borderColor: '{purple.200}',
          color: '{purple.500}',
        },
        danger: {
          hoverBackground: '{red.50}',
          activeBackground: '{red.100}',
          borderColor: '{red.200}',
          color: '{red.500}',
        },
        contrast: {
          hoverBackground: '{surface.50}',
          activeBackground: '{surface.100}',
          borderColor: '{surface.700}',
          color: '{surface.950}',
        },
        plain: {
          hoverBackground: '{surface.50}',
          activeBackground: '{surface.100}',
          borderColor: '{surface.200}',
          color: '{surface.700}',
        },
      },
      text: {
        primary: {
          hoverBackground: '{primary.50}',
          activeBackground: '{primary.100}',
          color: '{primary.color}',
        },
        secondary: {
          hoverBackground: '{surface.50}',
          activeBackground: '{surface.100}',
          color: '{surface.500}',
        },
        success: {
          hoverBackground: '{green.50}',
          activeBackground: '{green.100}',
          color: '{green.500}',
        },
        info: {
          hoverBackground: '{sky.50}',
          activeBackground: '{sky.100}',
          color: '{sky.500}',
        },
        warn: {
          hoverBackground: '{orange.50}',
          activeBackground: '{orange.100}',
          color: '{orange.500}',
        },
        help: {
          hoverBackground: '{purple.50}',
          activeBackground: '{purple.100}',
          color: '{purple.500}',
        },
        danger: {
          hoverBackground: '{red.50}',
          activeBackground: '{red.100}',
          color: '{red.500}',
        },
        plain: {
          hoverBackground: '{surface.50}',
          activeBackground: '{surface.100}',
          color: '{surface.700}',
        },
      },
      link: {
        color: '{primary.color}',
        hoverColor: '{primary.hover.color}',
        activeColor: '{primary.hover.color}',
      },
    },
    dark: {
      root: {
        primary: {
          background: '{primary.color}',
          hoverBackground: '{primary.hover.color}',
          activeBackground: '{primary.active.color}',
          borderColor: '{primary.color}',
          hoverBorderColor: '{primary.hover.color}',
          activeBorderColor: '{primary.active.color}',
          color: '{primary.contrast.color}',
          hoverColor: '{primary.contrast.color}',
          activeColor: '{primary.contrast.color}',
          focusRing: {
            color: '{primary.color}',
            shadow: 'none',
          },
        },
        secondary: {
          background: '{surface.800}',
          hoverBackground: '{surface.700}',
          activeBackground: '{surface.600}',
          borderColor: '{surface.800}',
          hoverBorderColor: '{surface.700}',
          activeBorderColor: '{surface.600}',
          color: '{surface.300}',
          hoverColor: '{surface.200}',
          activeColor: '{surface.100}',
          focusRing: {
            color: '{surface.300}',
            shadow: 'none',
          },
        },
        info: {
          background: '{sky.400}',
          hoverBackground: '{sky.300}',
          activeBackground: '{sky.200}',
          borderColor: '{sky.400}',
          hoverBorderColor: '{sky.300}',
          activeBorderColor: '{sky.200}',
          color: '{sky.950}',
          hoverColor: '{sky.950}',
          activeColor: '{sky.950}',
          focusRing: {
            color: '{sky.400}',
            shadow: 'none',
          },
        },
        success: {
          background: '{green.400}',
          hoverBackground: '{green.300}',
          activeBackground: '{green.200}',
          borderColor: '{green.400}',
          hoverBorderColor: '{green.300}',
          activeBorderColor: '{green.200}',
          color: '{green.950}',
          hoverColor: '{green.950}',
          activeColor: '{green.950}',
          focusRing: {
            color: '{green.400}',
            shadow: 'none',
          },
        },
        warn: {
          background: '{orange.400}',
          hoverBackground: '{orange.300}',
          activeBackground: '{orange.200}',
          borderColor: '{orange.400}',
          hoverBorderColor: '{orange.300}',
          activeBorderColor: '{orange.200}',
          color: '{orange.950}',
          hoverColor: '{orange.950}',
          activeColor: '{orange.950}',
          focusRing: {
            color: '{orange.400}',
            shadow: 'none',
          },
        },
        help: {
          background: '{purple.400}',
          hoverBackground: '{purple.300}',
          activeBackground: '{purple.200}',
          borderColor: '{purple.400}',
          hoverBorderColor: '{purple.300}',
          activeBorderColor: '{purple.200}',
          color: '{purple.950}',
          hoverColor: '{purple.950}',
          activeColor: '{purple.950}',
          focusRing: {
            color: '{purple.400}',
            shadow: 'none',
          },
        },
        danger: {
          background: '{red.400}',
          hoverBackground: '{red.300}',
          activeBackground: '{red.200}',
          borderColor: '{red.400}',
          hoverBorderColor: '{red.300}',
          activeBorderColor: '{red.200}',
          color: '{red.950}',
          hoverColor: '{red.950}',
          activeColor: '{red.950}',
          focusRing: {
            color: '{red.400}',
            shadow: 'none',
          },
        },
        contrast: {
          background: '{surface.0}',
          hoverBackground: '{surface.100}',
          activeBackground: '{surface.200}',
          borderColor: '{surface.0}',
          hoverBorderColor: '{surface.100}',
          activeBorderColor: '{surface.200}',
          color: '{surface.950}',
          hoverColor: '{surface.950}',
          activeColor: '{surface.950}',
          focusRing: {
            color: '{surface.0}',
            shadow: 'none',
          },
        },
      },
      outlined: {
        primary: {
          hoverBackground: 'color-mix(in srgb, {primary.color}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {primary.color}, transparent 84%)',
          borderColor: '{primary.700}',
          color: '{primary.color}',
          background: '{white}',
        },
        secondary: {
          hoverBackground: 'rgba(255,255,255,0.04)',
          activeBackground: 'rgba(255,255,255,0.16)',
          borderColor: '{surface.700}',
          color: '{surface.400}',
        },
        success: {
          hoverBackground: 'color-mix(in srgb, {green.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {green.400}, transparent 84%)',
          borderColor: '{green.700}',
          color: '{green.400}',
        },
        info: {
          hoverBackground: 'color-mix(in srgb, {sky.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {sky.400}, transparent 84%)',
          borderColor: '{sky.700}',
          color: '{sky.400}',
        },
        warn: {
          hoverBackground: 'color-mix(in srgb, {orange.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {orange.400}, transparent 84%)',
          borderColor: '{orange.700}',
          color: '{orange.400}',
        },
        help: {
          hoverBackground: 'color-mix(in srgb, {purple.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {purple.400}, transparent 84%)',
          borderColor: '{purple.700}',
          color: '{purple.400}',
        },
        danger: {
          hoverBackground: 'color-mix(in srgb, {red.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {red.400}, transparent 84%)',
          borderColor: '{red.700}',
          color: '{red.400}',
        },
        contrast: {
          hoverBackground: '{surface.800}',
          activeBackground: '{surface.700}',
          borderColor: '{surface.500}',
          color: '{surface.0}',
        },
        plain: {
          hoverBackground: '{surface.800}',
          activeBackground: '{surface.700}',
          borderColor: '{surface.600}',
          color: '{surface.0}',
        },
      },
      text: {
        primary: {
          hoverBackground: 'color-mix(in srgb, {primary.color}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {primary.color}, transparent 84%)',
          color: '{primary.color}',
        },
        secondary: {
          hoverBackground: '{surface.800}',
          activeBackground: '{surface.700}',
          color: '{surface.400}',
        },
        success: {
          hoverBackground: 'color-mix(in srgb, {green.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {green.400}, transparent 84%)',
          color: '{green.400}',
        },
        info: {
          hoverBackground: 'color-mix(in srgb, {sky.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {sky.400}, transparent 84%)',
          color: '{sky.400}',
        },
        warn: {
          hoverBackground: 'color-mix(in srgb, {orange.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {orange.400}, transparent 84%)',
          color: '{orange.400}',
        },
        help: {
          hoverBackground: 'color-mix(in srgb, {purple.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {purple.400}, transparent 84%)',
          color: '{purple.400}',
        },
        danger: {
          hoverBackground: 'color-mix(in srgb, {red.400}, transparent 96%)',
          activeBackground: 'color-mix(in srgb, {red.400}, transparent 84%)',
          color: '{red.400}',
        },
        plain: {
          hoverBackground: '{surface.800}',
          activeBackground: '{surface.700}',
          color: '{surface.0}',
        },
      },
      link: {
        color: '{primary.color}',
        hoverColor: '{primary.color}',
        activeColor: '{primary.color}',
      },
    },
  },
};

export default button;
